import type { RefObject } from "react";
import { PullToRefresh } from "@/components/ui/pull-to-refresh";
import { AuditsPane } from "../audits/AuditsPane";
import type { UseAuditsResult } from "../audits/useAudits";
import type { ScopeLabelCache } from "../audits/useScopeLabelCache";

export interface AuditsViewProps {
  auditsState: UseAuditsResult;
  selectedAuditId: string | null;
  scopeLabels: ScopeLabelCache;
  listScrollRef: RefObject<HTMLElement | null>;
  onSelectAudit: (id: string) => void;
}

/**
 * Audits list pane. Type/rating/visibility controls live in the shared
 * Guardians toolbar; this view only owns the scrollable results list.
 */
export function AuditsView({
  auditsState,
  selectedAuditId,
  scopeLabels,
  listScrollRef,
  onSelectAudit,
}: AuditsViewProps) {
  return (
    <PullToRefresh
      scrollRef={listScrollRef}
      onRefresh={auditsState.refresh}
      className="min-h-0 flex-1"
      data-testid="audits-pull-to-refresh"
    >
      <AuditsPane
        audits={auditsState.audits}
        loading={auditsState.loading}
        loadingMore={auditsState.loadingMore}
        error={auditsState.error}
        selectedId={selectedAuditId}
        onSelect={onSelectAudit}
        hasMore={auditsState.hasMore}
        onLoadMore={auditsState.loadMore}
        scrollRootRef={listScrollRef}
        scopeLabels={scopeLabels}
      />
    </PullToRefresh>
  );
}
